<template>
  <div class="fts-form-sync" :data-form-sync="syncState" v-if="needSync">
    <fts-tippy
      :content="`Form synced on ${syncLastTime}`"
      append-trigger-class="fts-form-sync__trigger"
      key="synced"
      v-if="syncState === 'synced'"
    >
      <font-awesome-icon
        :icon="['far', 'check-circle']"
        class="form-sync-icon form-sync-icon--success"
        @click="toggleSynchronize({})"
      />
    </fts-tippy>

    <fts-tippy
      content="Form sync failed. Resync to retry."
      append-trigger-class="fts-form-sync__trigger"
      key="error"
      v-else-if="syncState === 'resync'"
    >
      <div class="form-sync-wrapper">
        <font-awesome-icon
          :icon="['far', 'times-circle']"
          class="form-sync-icon form-sync-icon--error"
          @click="toggleSynchronize({})"
        />
        <div class="form-sync-action">resync</div>
      </div>
    </fts-tippy>

    <fts-tippy
      content="Form syncing"
      key="syncing"
      v-else
    >
      <font-awesome-icon
        :icon="['fas', 'sync-alt']"
        spin
        class="form-sync-icon"
      />
    </fts-tippy>
  </div>
</template>

<script>
import moment from 'moment';
import { classificationStore } from '../../store/classificationStore';

import FTSTippy from '../FTSTippy';

export default {
  components: {
    "fts-tippy": FTSTippy
  },
  props: {
    synchronize: Function
  },
  methods: {
    moment,
    toggleSynchronize(payload) {
      if (typeof this.synchronize === "function") this.synchronize(payload);
      else console.warn('TypeError: "synchronize" is not a function.');
    },
  },
  computed: {
    needSync() {
      return classificationStore.state.needSync;
    },
    syncLastTime() {
      return (
        classificationStore.state.syncLastTime &&
        moment(classificationStore.state.syncLastTime).format("lll")
      );
    },
    syncState() {
      if (this.needSync) {
        if (classificationStore.state.synchronizing) return "syncing";
        else if (classificationStore.state.syncError) return "resync";
        else return "synced";
      }
    }
  }
};
</script>

<style lang="scss">
.fts-form-sync {
  font-size: 1rem;
  .fts-form-sync__trigger {
    display: flex;
  }
  .form-sync-icon {
    color: var(--fts-default);
    &.form-sync-icon--success {
      color: var(--fts-success);
    }
    &.form-sync-icon--error {
      color: var(--fts-danger);
    }
  }
  .form-sync-wrapper {
    display: flex;
    align-items: center;
  }
  .form-sync-action {
    margin-left: 0.25rem;
    font-size: 0.875rem;
    line-height: 1rem;
    color: var(--fts-default);
    cursor: pointer;
    &:hover {
      color: var(--fts-primary);
    }
  }
}
</style>